<script>
import { List, Cell, Col, Row, Image, Icon, Empty, Switch, Toast, Popup } from 'vant'
import BottomToolbar from '@/components/org/BottomToolbar'
import DateTimeFunc from '@/tbs/util/DateTimeFunc'
import { QNImageUtil } from '@/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-match-signup-payment',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-list': List,
        'van-cell': Cell,
        'van-row': Row,
        'van-col': Col,
        'van-image': Image,
        'van-icon': Icon,
        'van-empty': Empty,
        'van-switch': Switch,
        'van-popup': Popup,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            match: {
                id: null,
                isPaymentOn: null,
            },
            matchSignup: {
                signupList: [],
            },
            showPopup: null,
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        isSignupListEmtpy() {
            return this.matchSignup.signupList && (this.matchSignup.signupList.length == 0)
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onConfigBtnClick() {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgDetailMatchSignupConfig',
                    params: {
                        id: this.match.id
                    },
                }
            })
        },
        onPaymentToggleBtnClick() {
            Toast(this.locale['coming-soon'])
        },
        onCreateBtnClick() {
            console.log('onCreateBtnClick')
            this.showPopup = true
        },
        onCreateSignupTableBtnClick() {
            if (this.matchSignup.signupList && (this.matchSignup.signupList.length == 0)) {
                this.$emit('custom-event', {
                    type: 'navigate',
                    data: {
                        name: 'OrgCreateMatchSignupPayment',
                        params: {
                            id: this.match.id
                        },
                    }
                })
            }
        },
        onCreatePaymentTableBtnClick() {
            Toast(this.locale['coming-soon'])
        },
        onSignupItemClick(item) {
            this.$emit('custom-event', {
                    type: 'navigate',
                    data: {
                        name: 'OrgDetailMatchSignupPayment',
                        params: {
                            id: item.id
                        },
                    }
                })
        },
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
        /**
         * @private
         * Format the date object as the yyyy.MM.dd hh:mm format string.
         * @param dateTime The date object.
         * @return The formatted date time string.
         */
        formatDateTime(dateTime) {
            return DateTimeFunc.formatDate(dateTime, 'yyyy.MM.dd hh:mm')
        },
    },
}
</script>

<template>
    <div class="match-signup-payment-manage">
        <div class="feature-cards">
            <van-row gutter="5">
                <van-col span="12">
                    <div class="feature-card bg-main">
                        <div class="header bg-white u-outer-padding vertical-center">
                            <span class="title-label minor-title">{{ locale['online-signup'] }}</span>
                            <div class="hot-tag-wrapper inline-block">
                                <span class="hot-tag inline-block vertical-center justify-center">
                                    <span class="tag-label support-text danger-color">{{ locale['limited-free'] }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="body bg-white u-inner-padding b-inner-padding">
                            <div>
                                <span class="success-color"><i class="iconfont iconfont-icon-select"/></span>
                                <span class="l-inner-margin minor-text minor-color lhr">{{ locale['data-collection'] }}</span>
                            </div>
                            <div>
                                <span class="success-color"><i class="iconfont iconfont-icon-select"/></span>
                                <span class="l-inner-margin minor-text minor-color lhr">{{ locale['audit-information'] }}</span>
                            </div>
                            <div>
                                <span class="success-color"><i class="iconfont iconfont-icon-select"/></span>
                                <span class="l-inner-margin minor-text minor-color lhr">{{ locale['rapid-build-team'] }}</span>
                            </div>
                        </div>
                        <div class="footer u-inner-padding vertical-center" @click="onConfigBtnClick">
                            <span class="normal-text primary-color">{{ locale['signup-data-config'] }}</span>
                        </div>
                    </div>
                </van-col>
                <van-col span="12">
                    <div class="feature-card bg-main">
                        <div class="header bg-white u-outer-padding vertical-center">
                            <span class="title-label minor-title">{{ locale['online-payment'] }}</span>
                        </div>
                        <div class="body bg-white u-inner-padding b-inner-padding">
                            <div>
                                <span class="success-color"><i class="iconfont iconfont-icon-select"/></span>
                                <span class="l-inner-margin minor-text minor-color lhr">{{ locale['withdraw-anytime'] }}</span>
                            </div>
                            <div>
                                <span class="success-color"><i class="iconfont iconfont-icon-select"/></span>
                                <span class="l-inner-margin minor-text minor-color lhr">{{ locale['rapid-transfer'] }}</span>
                            </div>
                            <div>
                                <span class="l-inner-margin minor-text color-white lhr">occupied</span>
                            </div>
                        </div>
                        <div class="footer relative u-inner-padding vertical-center">
                            <span class="normal-text primary-color">{{ locale['open'] }}</span>
                            <span class="switcher" @click="onPaymentToggleBtnClick">
                                <van-switch size="20px"/>
                            </span>
                        </div>
                    </div>
                </van-col>
            </van-row>
        </div>
        <div v-if="!isSignupListEmtpy" class="singup-list">
            <van-list>
                <div 
                    v-for="item in matchSignup.signupList" 
                    :key="item.id" 
                    class="bg-white u-outer-padding relative"
                    @click="onSignupItemClick(item)"
                >
                    <div class="inline-block">
                        <div class="relative" style="width: 64px;">
                            <img 
                                class="corner-round-sm relative"
                                :src="adjustImageSize(item.imageUrl, 128, 128)" 
                                style="width: 64px; height: 64px; top: -18px;"
                            />
                        </div>
                    </div>
                    <div class="inline-block l-outer-margin minor-text minor-color lhn">
                        <div>
                            <span class="main-text main-color">{{ item.name }}</span>
                        </div>
                        <div class="t-inner-margin">
                            <span>{{ locale['match-signup-start-time-label'] }}</span>
                            <span>{{ locale['semicolon'] }}</span>
                            <span class="l-inner-margin">{{ formatDateTime(item.startDateTime) }}</span>
                        </div>
                        <div class="t-inner-margin">
                            <span>{{ locale['match-signup-end-time-label'] }}</span>
                            <span>{{ locale['semicolon'] }}</span>
                            <span class="l-inner-margin">{{ formatDateTime(item.endDateTime) }}</span>
                        </div>
                        <div class="t-inner-margin">
                            <span>{{ locale['match-signup-team-total-label'] }}</span>
                            <span>{{ locale['semicolon'] }}</span>
                            <span class="l-inner-margin">{{ item.teamTotal }}</span>
                        </div>
                    </div>
                    <div class="pull-right relative" style="top: 33px;">
                        <span><i class="iconfont iconfont-right icon-size-20"/></span>
                    </div>
                    <div v-if="item.statusLabel" class="status-overlap text-center">
                        <span class="minor-text color-white text-right">{{ item.statusLabel }}</span>
                    </div>
                </div>
            </van-list>
        </div>
        <div v-else @click="onCreateBtnClick">
            <van-empty 
                :description="locale['signup-empty-hint']"
                image="search"
            />
        </div>
        <bottom-toolbar 
            type="button" 
            :mainButtonLabel="locale['create']"
            @click-main-button="onCreateBtnClick"
        />
        <van-popup v-model="showPopup" position="bottom" class="popup-container">
            <div>
                <div class="title-section text-center b-outer-margin">
                    <span class="main-title">{{ locale['create-signup-link'] }}</span>
                    <span class="close-btn" @click="showPopup = false">
                        <i class="iconfont iconfont-close-black"/>
                    </span>
                </div>
                <div 
                    class="u-outer-padding vertical-center" 
                    @click="onCreateSignupTableBtnClick">
                    <div v-if="isSignupListEmtpy">
                        <div class="inline-block">
                            <img src="@/assets/org/badge-symbol.png" style="width: 20px; height: 25px;"/>
                        </div>
                        <div class="inline-block l-outer-margin">
                            <div>
                                <span class="main-text main-color">{{ locale['online-signup-table-label'] }}</span>
                            </div>
                            <div>
                                <span class="minor-text minor-color">{{ locale['online-signup-table-desc-1'] }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="inline-block">
                            <img src="@/assets/org/badge-grey-symbol.png" style="width: 20px; height: 25px;"/>
                        </div>
                        <div class="inline-block l-outer-margin">
                            <div>
                                <span class="main-text disable-color">{{ locale['online-signup-table-label'] }}</span>
                            </div>
                            <div>
                                <span class="minor-text disable-color">{{ locale['online-signup-table-desc-2'] }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div 
                    class="u-outer-padding vertical-center b-wide-margin relative" 
                    @click="onCreatePaymentTableBtnClick">
                    <div class="inline-block">
                        <img src="@/assets/org/flag-symbol.png" style="width: 20px; height: 20px;"/>
                    </div>
                    <div class="inline-block l-outer-margin">
                        <div>
                            <span class="main-text main-color">{{ locale['online-payment-table-label'] }}</span>
                        </div>
                        <div>
                            <span class="minor-text minor-color">{{ locale['online-payment-table-desc'] }}</span>
                        </div>
                    </div>
                    <div class="full-separator-line-top"/>
                </div>
            </div>
            <div class="unsafe-area-bottom-mask"/>
        </van-popup>
    </div>
</template>

<style scoped>
.feature-cards {
    margin: 10px;
}
.feature-card {
    width: 175px;
    height: 145px;
    border-radius: 4px;
}
.header {
    height: 22px;
}
.hot-tag-wrapper {
    position: absolute;
    right: 8px;
}
.hot-tag {
    width: 58px;
    height: 16px;
    border-radius: 99px;
    background: rgba(255, 211, 205, 0.38);
}
.footer {
    height: 38px;
}
.switcher {
    position: absolute;
    right: 8px;
}
.status-overlap {
    position: absolute;
    right: 0;
    top: 10px;
    width: 56px;
    height: 18px;
    border-radius: 30px 0px 0px 30px;
    background: #7CE711;
}
</style>